import { colors, IconImage } from 'bold-ui'
import {
  ClassificacaoPrioridadeCuidadoEnum,
  HistoricoRegulacaoEvolucaoQuery,
  ListaRegulacaoQuery,
  StatusRegulacaoEnum,
  TipoRegulacaoEnum,
} from 'graphql/types.generated'

export type ListaRegulacamTableItem = ListaRegulacaoQuery['listaRegulacao']['content'][0]
export type RegulacaoEvolucaoModel = HistoricoRegulacaoEvolucaoQuery['evolucoesRegulacao'][0]

export type StatusRegulacaoEnumRecord = {
  icon: IconImage
  text: string
  color: string
}

export const StatusRegulacaoEnumMap: Record<StatusRegulacaoEnum, StatusRegulacaoEnumRecord> = {
  AGUARDANDO_ENVIO: { icon: 'clockOutline', text: 'Pendente', color: colors.yellow.c40 },
}

export const fakeDataGuiaEncaminhamento: ListaRegulacamTableItem = {
  id: '_1',
  uuid: 'meuUUIDbonito',
  lotacao: {
    id: '_1',
    cbo: {
      id: '_1',
      nome: 'MEU CBO',
    },
    profissional: {
      id: '_1',
      nome: 'Lucas Maritns Petroski Ouum Nome Realmente Muito Grande',
    },
    unidadeSaude: {
      id: '_1',
      nome: 'UBS Nome da UBS',
    },
    // equipe: {
    //   id: '_1',
    //   nome: 'NOME DA MINHA EQUIPE MAROTA',
    // },
  },
  prontuario: {
    id: '_1',
    cidadao: {
      id: '4',
      nome: 'Cidadao TESTE',
      dataNascimento: new Date(),
      cidadaoVinculacaoEquipe: {
        id: '_1',
        unidadeSaude: {
          id: '_1',
          nome: 'UBS Da Vinculacao',
        },
        // equipe: {
        //   id: '_1',
        //   nome: 'Equioe da vinculacao',
        // },
      },
    },
  },
  guiaEncaminhamento: {
    id: '_1',
    cbo: {
      id: '_1',
      nome: 'Nome cbo da guia',
    },
    ciap: {
      id: '_1',
      codigo: 'NÁUSEA',
      descricao: 'D09',
    },
    cid10: {
      id: '_1',
      nome: 'ASSEPSIA INSUFICIENTE DURANTE A PRESTAÇÃO DE CUIDADOS CIRÚRGICOS E MÉDICOS',
      codigo: 'Y62',
    },
    atendimentoProfissional: {
      id: '_1',
      finalizadoEm: new Date(),
    },
    classificacaoPrioridade: ClassificacaoPrioridadeCuidadoEnum.ALTA,
  },
  tipoRegulacao: TipoRegulacaoEnum.GUIA_ENCAMINHAMENTO,
  ultimaEvolucao: {
    id: '_1',
    dataEvolucao: new Date(),
    statusRegulacao: StatusRegulacaoEnum.AGUARDANDO_ENVIO,
    observacao:
      'MF, 47 anos, não faz uso de nenhuma medicação. Histórico de três partos normais sem intercorrências. Realizou laqueadura fazem 06 anos. Apresenta queixa de cistos mamários simples. Em exame de USG das mamas realizado em abril de 2023, observa-se cisto simples de 8x6mm na mama direita. ',
  },
}

export const fakeGuiaEncaminhamentoEvolucoes: RegulacaoEvolucaoModel[] = [
  {
    id: '1',
    dataEvolucao: new Date(),
    statusRegulacao: StatusRegulacaoEnum.AGUARDANDO_ENVIO,
    observacao:
      'MF, 47 anos, não faz uso de nenhuma medicação. Histórico de três partos normais sem intercorrências. Realizou laqueadura fazem 06 anos. Apresenta queixa de cistos mamários simples. Em exame de USG das mamas realizado em abril de 2023, observa-se cisto simples de 8x6mm na mama direita. ',
  },
  {
    id: '2',
    dataEvolucao: new Date(),
    statusRegulacao: StatusRegulacaoEnum.AGUARDANDO_ENVIO,
    observacao: null,
  },
  {
    id: '3',
    dataEvolucao: new Date(),
    statusRegulacao: StatusRegulacaoEnum.AGUARDANDO_ENVIO,
    observacao:
      'MF, 47 anos, não faz uso de nenhuma medicação. Histórico de três partos normais sem intercorrências. Realizou laqueadura fazem 06 anos. Apresenta queixa de cistos mamários simples. Em exame de USG das mamas realizado em abril de 2023, observa-se cisto simples de 8x6mm na mama direita. ',
  },
]

export const fakeDataExame: ListaRegulacamTableItem = {
  id: '_1',
  uuid: 'meuUUIDbonito2',
  lotacao: {
    id: '_1',
    cbo: {
      id: '_1',
      nome: 'MEU CBO MEDICO',
    },
    profissional: {
      id: '_1',
      nome: 'Lucas Maritns Petroski',
    },
    unidadeSaude: {
      id: '_1',
      nome: 'Nome da UBS',
    },
  },
  prontuario: {
    id: '_1',
    cidadao: {
      id: '4',
      nome: 'Cidadao Fake',
      dataNascimento: new Date(),
      cidadaoVinculacaoEquipe: {
        id: '_1',
        unidadeSaude: {
          id: '_1',
          nome: 'UBS Da Vinculacao 2',
        },
      },
    },
  },
  exame: {
    id: '_1',
    exame: {
      id: '_1',
      codigo: '000010110',
      descricao: 'nome do exame',
    },
    atendimentoProfissional: {
      id: '_1',
      finalizadoEm: new Date(),
    },
  },
  tipoRegulacao: TipoRegulacaoEnum.SOLICITACAO_EXAME_COMUM,
  ultimaEvolucao: {
    id: '_1',
    dataEvolucao: new Date(),
    statusRegulacao: StatusRegulacaoEnum.AGUARDANDO_ENVIO,
  },
}
